package one.healthium.insights.ui.personal_mealplan

import one.healthium.insights.domain.models.MealPlanResultModel
import one.healthium.insights.domain.models.RecipeModel
import androidx.compose.runtime.Immutable

@Immutable
internal data class PersonalMealPlanUiState(
    val loading: Boolean = true,
    val result: MealPlanResultModel? = null,
    val isMetrics: Boolean = false,
    val selectedDayIndex: Int = 0,
    val selectedRecipe: SelectedRecipe? = null,
)

internal data class SelectedRecipe(
    val recipe: RecipeModel,
    val mealType: String,
)
